import React from "react";

const PharmaWorksheet = () => {
  return (
    <div className="bg-gray-10 border-1 border-gray-100 p-2  flex flex-col max-w-[281px] ">
      <p className="text-teal-300 text-sm  font-normal">
      Notes may be shared with the patient and/or primary prescriber on request
      </p>
    </div>
  );
};

export default PharmaWorksheet;